import { useLDFlags } from './LD/useLDFlags';

export const useShouldShowNewPricingSkinnyBanner = () => {
  const { 'experiment-new-pricing-promo-banners': newPricingPromoBannersFlag } =
    useLDFlags();

  return newPricingPromoBannersFlag?.skinnyBanner ?? false;
};
